/**
 * @flow
 * @relayHash b149799f6c15425a8bb019c87fbf63c2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type BlocExistsQueryVariables = {|
  tenantPks: $ReadOnlyArray<?number>
|};
export type BlocExistsQueryResponse = {|
  +blocExists: ?{|
    +bloc: ?{|
      +name: string
    |},
    +error: ?{|
      +statusCode: ?number
    |},
  |}
|};
export type BlocExistsQuery = {|
  variables: BlocExistsQueryVariables,
  response: BlocExistsQueryResponse,
|};
*/


/*
query BlocExistsQuery(
  $tenantPks: [Int]!
) {
  blocExists(tenantPks: $tenantPks) {
    bloc {
      name
      id
    }
    error {
      statusCode
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "tenantPks",
    "type": "[Int]!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "tenantPks",
    "variableName": "tenantPks",
    "type": "[Int]!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "error",
  "storageKey": null,
  "args": null,
  "concreteType": "ErrorType",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "statusCode",
      "args": null,
      "storageKey": null
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "BlocExistsQuery",
  "id": "3b02923f43b0a2b07ab067d21c36fef6",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "BlocExistsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blocExists",
        "storageKey": null,
        "args": v1,
        "concreteType": "BlocDetailsPageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "bloc",
            "storageKey": null,
            "args": null,
            "concreteType": "BlocType",
            "plural": false,
            "selections": [
              v2
            ]
          },
          v3
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "BlocExistsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "blocExists",
        "storageKey": null,
        "args": v1,
        "concreteType": "BlocDetailsPageType",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "bloc",
            "storageKey": null,
            "args": null,
            "concreteType": "BlocType",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          },
          v3
        ]
      }
    ]
  }
};
})();
node.text = "query BlocExistsQuery(\n  $tenantPks: [Int]!\n) {\n  blocExists(tenantPks: $tenantPks) {\n    bloc {\n      name\n      id\n    }\n    error {\n      statusCode\n    }\n  }\n}\n";
(node/*: any*/).hash = '6dd0a8e71474aac114ea9a1596ec72de';
module.exports = node;
